import type { ReactNode } from "react";
import { HelpLink } from "@/features/docs/HelpLink";

export function AdminPageHeader({
  eyebrow,
  title,
  description,
  meta,
  actions,
}: {
  eyebrow: string;
  title: string;
  description: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header
      data-admin-page-heading
      className="grid gap-3 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-start"
    >
      <div className="min-w-0">
        <p className="text-[0.6rem] font-display uppercase tracking-wider text-ink-muted">
          {eyebrow}
        </p>
        <h2 className="text-xl font-display uppercase tracking-wider text-ink">
          {title}
        </h2>
        <p className="mt-1 max-w-3xl text-sm text-ink-muted">{description}</p>
      </div>
      {/* Right column always renders so the contextual help link has a home;
       * it flows in the header row (not an absolute overlay), so it never
       * collides with page meta/actions. */}
      <div className="flex items-center gap-2 justify-self-start lg:justify-self-end">
        {meta ? (
          <span className="text-xs font-mono text-ink-muted">{meta}</span>
        ) : null}
        {actions}
        <HelpLink />
      </div>
    </header>
  );
}
